import {useWindowDimensions} from 'platform/foundation';

export function useSkeletonRowCount(minRowHeightPx: number) {
  const {height} = useWindowDimensions();
  return Math.ceil(height / minRowHeightPx);
}
